export default "__VITE_ASSET__DOPbdHzK__"